import dayjs from 'dayjs';
import _ from 'underscore';
import { RandomWords } from 'utils/random-words';

/**
 * Generate a random float
 * @param max The max number that to be returned. Default is 100.
 */
export const randomFloat = (max = 100, decimal = 2): number => parseFloat((Math.random() * max).toFixed(decimal));

/**
 * Generate a random integer
 * @param maxNumber The max number that to be returned. Default is 100.
 */
export const randomInteger = (maxNumber = 100): number => Math.round(randomFloat(maxNumber));

/**
 * Generates a random boolean
 * @returns
 */
export const randomBoolean = (): boolean => Math.random() >= 0.5;

/**
 * Generate a random string.
 * @param length The length of the string to be returned. Default is 20.
 */
export const randomString = (length = 20): string => _.times(length, () => _.random(35).toString(36)).join('');

/**
 * Generate a string consisting of random "words". Words are space separated strings.
 */
export const randomWords = (wordCount = 5, maxWordLength = 10): string => {
  return _.times(Math.floor(Math.random() * (wordCount - 1) + 1), () => _.sample(RandomWords)).join(' ');
};

/**
 * Generate a random date between today and `max` days in the future. If `subtract`, will generate a date between today and `max` days in the past
 * @param max
 * @param subtract
 * @returns `string`
 */
export const randomDate = (max: number = 21, subtract: boolean = false) =>
  subtract ? dayjs().subtract(randomInteger(max), 'days').toISOString() : dayjs().add(randomInteger(max), 'days').toISOString();

/**
 * Generate a random 36 character UUID based on a date timestamp.
 * @returns `string
 */
export const randomUUID = (): string => {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

/**
 * Pick a random value from an enum.
 * @param EnumType The enum to pick a value from.
 */
export const randomEnum = <T extends object>(EnumType: T): T[keyof T] => _.sample(Object.values(EnumType)) as T[keyof T];
